
import "./CreateClient.css";
import React, { useState, Dispatch } from "react";
import { useGlobalContext } from "../../context";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import americanExpress from "../../Assets/americanExpressLogo.png";
import visa from "../../Assets/visaLogo.png";
import discover from "../../Assets/discoverLogo.png";
import masterCard from "../../Assets/masterCard.png";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

type creditCardProps = {
    cardholderNameValue: string,
    creditCardNumbersValue: string | undefined,
    cardDigitNumValue : string,
    cardExpDateValue : string,
    monthlyRecurringValue : string,
    billingAddressValue : string,
    signUpDateValue : Value | string | undefined,
    billingDateValue : string,
    billingNotesValue : string,
    setCardholderNameValue:  Dispatch<React.SetStateAction<string>>,
    setCreditCardNumbersValue: (creditCardNumbersValue:string | undefined) => void,
    setCardDigitNumValue:  Dispatch<React.SetStateAction<string>>,
    setCardExpDateValue :  Dispatch<React.SetStateAction<string>>,
    setMonthlyRecurringValue:  Dispatch<React.SetStateAction<string>>,
    setBillingAddressValue : Dispatch<React.SetStateAction<string>>,
    setSignUpDateValue:  Dispatch<React.SetStateAction<Value | string | undefined>>,
    setBillingDateValue :  Dispatch<React.SetStateAction<string>>,
    setBillingNotesValue :  Dispatch<React.SetStateAction<string>>
}

function CreditCard(props: creditCardProps) {

    const {
        cardholderNameValue,
        cardDigitNumValue,
        cardExpDateValue,
        monthlyRecurringValue,
        billingAddressValue,
        signUpDateValue,
        billingDateValue,
        creditCardNumbersValue,
        billingNotesValue,
        setCreditCardNumbersValue,
        setBillingAddressValue,
        setSignUpDateValue,
        setBillingDateValue,
        setBillingNotesValue,
        setMonthlyRecurringValue,
        setCardDigitNumValue,
        setCardExpDateValue,
        setCardholderNameValue
    } = props

    const { cNumberFormat } = useGlobalContext();

    const [cardLogo, setCardLogo] = useState<string>('');
    const [cNumberAlert, setCNumberAlert] = useState<boolean>(false);

    const cNumbersImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCreditCardNumbersValue(cNumberFormat(value));

        if (value.startsWith('3')) {
            setCardLogo(americanExpress);
            setCNumberAlert(false);
        }
        else if (value.startsWith('4')) {
            setCardLogo(visa);
            setCNumberAlert(false);
        }
        else if (value.startsWith('5')) {
            setCardLogo(masterCard);
            setCNumberAlert(false);
        }
        else if (value.startsWith('6')) {
            setCardLogo(discover);
            setCNumberAlert(false);
        }
        else if (value === '') {
            setCNumberAlert(false);
        }
        else {
            setCardLogo('');
            setCNumberAlert(true);
        }
    }

    const checkingDigitValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setCardDigitNumValue(value)
        if (creditCardNumbersValue?.startsWith('3')) {
            if (value.length > 4) {
                setCardDigitNumValue(value.slice(0, 4));
            }
        }
        else {
            if (value.length > 3) setCardDigitNumValue(value.slice(0, 3));
        }
    }

    const changeExpireDate = (value: string) => {
        setCardExpDateValue("");
        if (value.length >= 2) {
            const firstTwoValue = value.substring(0, 2);
            const beforeTwoValue = value.substring(3);
            setCardExpDateValue(`${firstTwoValue}/${beforeTwoValue}`);
        }
        else {
            setCardExpDateValue(value);
        }
    }

    const changeMonthlyRecurring = (value: string) => {
        const newValue: string = value.replace(/\$/g, '');
        setMonthlyRecurringValue("$" + newValue);
    }

    return (
        <div className="CreditCard">
            <div className="createClient-form-cc">
                <div className="createClient-form-cc-heading">
                    <h2>Credit Card Information</h2>
                </div>
                <div className="createClient-form-type">
                    <div className="form-type-box">
                        <label>Name</label>
                    </div>
                    <div className="form-type-box mrg-btm">
                        <input
                            id = "holderNameInp"
                            className = "type-box-type-input"
                            type = "text"
                            value = { cardholderNameValue }
                            onChange = {e => setCardholderNameValue(e.target.value)}
                        />
                    </div>
                </div>
                <div className="createClient-form-type">
                    <div className="form-type-box">
                        <label>Numbers</label>
                    </div>
                    <div className="form-type-box mrg-btm">
                        <input
                            type = "text"
                            className = "type-box-type-input"
                            value = { creditCardNumbersValue }
                            onChange = { cNumbersImg }
                        />
                        {
                            cardLogo && <img src = { cardLogo } alt = "Credit Card Logo" />
                        }
                    </div>
                    <div className="ccNumbers-Wrong mrg-btm">
                        <span
                            style = {{
                                display: cNumberAlert ? "block" : "none"
                            }}
                        >
                            Wrong Card Numbers
                        </span>
                    </div>
                </div>
                <div className="createClient-form-cc-block">
                    <div className="cc-block-box">
                        <div className="form-type-box">
                            <label>CVV</label>
                        </div>
                        <div className="form-type-box mrg-btm">
                            <input
                                className = "type-box-type-input credit-card-small-input"
                                type = "number"
                                value = { cardDigitNumValue }
                                onChange = { checkingDigitValue }
                            />
                        </div>
                    </div>
                    <div className="cc-block-box">
                        <div className="form-type-box">
                            <label>Expiration Date</label>
                        </div>
                        <div className="form-type-box mrg-btm">
                            <input
                                placeholder = "mm/yy"
                                className = "type-box-type-input credit-card-small-input"
                                type = "text"
                                maxLength = { 5 }
                                value = { cardExpDateValue }
                                onChange = {e => changeExpireDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="cc-block-box">
                        <div className="form-type-box">
                            <label>Monthly Recurring</label>
                        </div>
                        <div className="form-type-box mrg-btm">
                            <input
                                className = "type-box-type-input credit-card-small-input"
                                placeholder = "$"
                                type = "text"
                                value = { monthlyRecurringValue }
                                onChange = {e => changeMonthlyRecurring(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="createClient-form-type">
                    <div className="form-type-box">
                        <label>Billing Address / Zip Code</label>
                    </div>
                    <div className="form-type-box mrg-btm">
                        <input
                            className = "type-box-type-input"
                            type = "text"
                            value = { billingAddressValue }
                            onChange = {e => setBillingAddressValue(e.target.value)}
                        />
                    </div>
                </div>
                <div className="createClient-form-cc-block">
                    <div className="cc-block-box mrg-btm">
                        <div className="form-type-box">
                            <label>Sign Up Date</label>
                        </div>
                        <div className="form-type-box">
                            <DatePicker
                                onChange = {e => {
                                    if (e) {
                                        setSignUpDateValue(e);
                                    }
                                }}
                                value = { signUpDateValue }
                                dayPlaceholder = {"dd"}
                                monthPlaceholder = {"mm"}
                                yearPlaceholder = {"yyyy"}
                                format = {"MM-dd-yyyy"}
                                clearIcon = { false }
                            />
                        </div>
                    </div>
                    <div className="cc-block-box mrg-btm">
                        <div className="form-type-box">
                            <label>Billing Date</label>
                        </div>
                        <div className="form-type-box">
                            <input
                                placeholder = ""
                                className = "type-box-type-input"
                                type = "number"
                                value = { billingDateValue }
                                onChange = {e => setBillingDateValue(e.target.value)}
                                // min={new Date().toJSON().slice(0, 10)}
                            />
                        </div>
                    </div>
                </div>
                <div className="createClient-form-type">
                    <div className="form-type-box">
                        <label>Billing Notes</label>
                    </div>
                    <div className="form-type-box mrg-btm">
                        <textarea
                            rows = {4}
                            className = "type-box-type-input"
                            value = { billingNotesValue }
                            onChange = {e => setBillingNotesValue(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreditCard